/**
 * Replace optional placeholders in domain-specific legal HTML.
 * Supported: {{brandname}}, {{brandurl}}, {{address}}
 */
export const interpolateLegal = (html, data = {}) => {
  if (!html) return ''

  return html
    .replace(/\{\{brandname\}\}/g, data.brandname || '')
    .replace(/\{\{brandurl\}\}/g, data.brandurl || '')
    .replace(/\{\{address\}\}/g, data.address || '')
}

/**
 * Load optional privacy.html / terms.html for a domain.
 * Missing files fall back to the shared templated components.
 */
export const loadLegalHtml = (domainName) => {
  let privacyHtml = null
  let termsHtml = null

  try {
    privacyHtml = require(`../domains/${domainName}/content/privacy.html`)
  } catch (e) {
    // Domain uses shared PrivacyPolicy template
  }

  try {
    termsHtml = require(`../domains/${domainName}/content/terms.html`)
  } catch (e) {
    // Domain uses shared Terms template
  }

  return { privacyHtml, termsHtml }
}
